export const checkIfSortPathsAreMatching = (sortConfig1, sortConfig2) => {
	return Object.keys(sortConfig1)[0] === Object.keys(sortConfig2)[0]
}

